import React from 'react';

import * as styles from './styles';
import { Button } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';

import Icon from '@cobliteam/ui/icons';

import { BackToTopButton } from '../Button';

interface TabProps {
  id?: string;
  disabled?: boolean;
  className?: string;
  children: {
    controls?: React.ReactNode;
    content: React.ReactNode;
  };
  innerRef?: React.Ref<HTMLDivElement>;
  onToggle?: (open: boolean) => void;
  onScroll?: (topScroll: number) => void;
}

interface TabState {
  open: boolean;
  scrollIsAtTop: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
class TabComponent extends React.Component<TabProps, TabState> {
  private sectionRef = React.createRef<HTMLDivElement>();

  constructor(props: TabProps) {
    super(props);

    this.state = {
      open: true,
      scrollIsAtTop: true,
    };
  }

  public componentDidUpdate(prevProps: TabProps) {
    const { disabled, onToggle } = this.props;

    if (onToggle && prevProps.disabled !== disabled) {
      onToggle(this.state.open);
    }
  }

  private handleTabToggle = () => {
    const { disabled, onToggle } = this.props;
    if (!disabled) {
      this.setState(
        (prevState) => ({ open: !prevState.open }),
        () => {
          if (onToggle) {
            onToggle(this.state.open);
          }
        }
      );
    }
  };

  private onClickBackToTopButton = () => {
    const sectionCurrent = this.getSectionCurrent();

    if (sectionCurrent) {
      sectionCurrent.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  private onScrollSection = () => {
    const sectionCurrent = this.getSectionCurrent();
    if (sectionCurrent) {
      const scrollIsAtTop = sectionCurrent.scrollTop === 0;
      this.setState({ scrollIsAtTop });

      if (this.props.onScroll) {
        this.props.onScroll(sectionCurrent.scrollTop);
      }
    }
  };

  private getSectionRef = () => {
    return this.props.innerRef || this.sectionRef;
  };

  private getSectionCurrent = () => {
    const ref = this.getSectionRef();
    if ('current' in ref) {
      return ref.current;
    }
    return null;
  };

  public render = () => {
    const { id, disabled, className, children } = this.props;
    const { open, scrollIsAtTop } = this.state;
    const { controls, content } = children;

    const showContent = open && !disabled;

    return (
      <div id={id} className={cn(styles.tab, className)}>
        <header className={styles.tabControls}>
          {controls}
          {controls && (
            <Button icon={<Icon name='chevron-down' className={styles.arrowIconStyle(open, disabled)} />} className={styles.toggle(disabled)} onClick={this.handleTabToggle} />
          )}
        </header>
        <section ref={this.getSectionRef()} className={styles.tabContent} onScroll={this.onScrollSection}>
          {showContent && (
            <>
              {content}
              {!scrollIsAtTop && <BackToTopButton onClick={this.onClickBackToTopButton} className={styles.backToTopButton} />}
            </>
          )}
        </section>
      </div>
    );
  };
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Tab = React.forwardRef(({ children, ...otherProps }: TabProps, ref: React.Ref<HTMLDivElement>) => (
  <TabComponent innerRef={ref} {...otherProps}>
    {children}
  </TabComponent>
));
